<template>
  <v-container class="container--large glossary padding-left-right">
    <div class="pt-4 mb-12">
      <v-skeleton-loader type="text" loading class="breadcrumb-loader" />
    </div>
    <div class="d-md-flex justify-space-between pt-6">
      <div class="mb-6 mb-md-0">
        <v-skeleton-loader type="text" loading class="heading-loader" />
      </div>
      <div class="d-flex">
        <v-skeleton-loader
          type="button"
          loading
          class="heading-button-loader-1"
        />
        <v-skeleton-loader
          type="button"
          loading
          class="heading-button-loader-2"
        />
      </div>
    </div>

    <v-row
      align="center"
      justify="center"
      class="mt-8 glossary__choices mb-8 pa-2"
    >
      <v-col cols="12" md="3">
        <v-skeleton-loader type="text" loading class="search-input-loader" />
      </v-col>

      <v-col cols="12" md="9" class="pa-0">
        <v-skeleton-loader type="text" loading class="letter-loader" />
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="center"
      class="mt-8 glossary__choices mb-8 pa-2"
    >
      <v-col cols="12">
        <v-skeleton-loader
          type="text"
          loading
          class="search-result-heading-loader"
        />
        <v-skeleton-loader
          v-for="i in 3"
          :key="i"
          type="text"
          loading
          class="search-result-text-loader"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.glossary__choices {
  background-color: #fff;
  box-shadow: 0px 0.375rem 1.125rem rgba(0, 0, 0, 0.06);
  border-radius: 0.25rem;
  margin: -0.0625rem;
}
.breadcrumb-loader {
  width: 200px;
}
.heading-loader {
  width: 200px;
  &::v-deep .v-skeleton-loader__text {
    height: 20px;
  }
}
.heading-button-loader-1 {
  margin-right: 12px;
  &::v-deep .v-skeleton-loader__button {
    width: 170px;
    height: 20px;
  }
}
.heading-button-loader-2 {
  &::v-deep .v-skeleton-loader__button {
    width: 100px;
    height: 20px;
  }
}
.search-input-loader {
  padding-bottom: 6px;
  padding-top: 12px;
  &::v-deep .v-skeleton-loader__text {
    height: 48px;
  }
}
.letter-loader {
  padding-top: 4px;
  padding-left: 10px;
  padding-right: 10px;
  &::v-deep .v-skeleton-loader__text {
    height: 16px;
  }
}
.search-result-heading-loader {
  margin-top: 40px;
  padding-bottom: 8px;
  width: 100px;
  &::v-deep .v-skeleton-loader__text {
    height: 22px;
  }
}
.search-result-text-loader {
  margin-top: 30px;
}
</style>
